import React from 'react'
import StoreName from './StoreName'
import Account from './Account'
import Notifications from './Notifications'
import useSupportFeedbackStore from '../../../../stores/supportFeedbackStore'

function TopBarDisplayTitle(props) {
  const { openSupportModal } = useSupportFeedbackStore()
  const showBetaButton = Boolean(props.betaSupportContext)

  const handleBetaClick = () => {
    if (props.betaSupportContext) {
      openSupportModal(props.betaSupportContext)
    }
  }

  return (
    <div className="py-5 px-6 border-b border-slate-200 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <h2 className="text-2xl text-slate-900">{props.title}</h2>
        {showBetaButton && (
          <button
            type="button"
            onClick={handleBetaClick}
            className="px-3 py-1 text-xs font-semibold uppercase tracking-wide rounded-full border border-violet-200 text-violet-700 bg-violet-50 hover:bg-violet-100"
          >
            Beta
          </button>
        )}
      </div>
      <div className="flex">
        <div className="mr-6 flex items-center">
          <StoreName
            storeOptions={props.storeOptions}
            homeStore={props.homeStore}
            storeNames={props.storeNames}
            change_home_store={props.change_home_store}
          />
        </div>
        <div className="mr-8">
          <Notifications
            homeStore={props.homeStore}
          />
        </div>
        <div className="cursor-pointer">
          <Account />
        </div>
      </div>
    </div>
  )
}

export default TopBarDisplayTitle
